
import _ from "lodash"
let isScrollTriggered = true

export default {
  name: "Navigate",
  props: {
    module: Object
  },
  data() {
    return {
      currentAnchor: "",
      expandNavigation: false,
      debounceScroll: null,
      debounceScrollToElement: null
    }
  },
  computed: {
    allCategories() {
      return this.$t("dshop.allCategories", { num: this.navigationList.length })
    },
    navigationList() {
      return this.module?.data?.list || []
    }
  },
  watch: {
    expandNavigation(val) {
      if (!val) {
        this.debounceScrollToElement(this.currentAnchor)
      }
    }
  },
  mounted() {
    this.currentAnchor = this.navigationList[0].anchor
    this.debounceScrollToElement = _.debounce(this.scrollToElement, 300)
    this.debounceScroll = _.debounce(this.handleScroll, 300)
    window.addEventListener("scroll", this.debounceScroll)
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.debounceScroll)
  },
  methods: {
    navigateTo(anchor) {
      isScrollTriggered = false
      this.currentAnchor = anchor
      const element = document.getElementById(`anchor-${anchor}`)
      if (element) {
        const offset = this.getOffsetHeight()
        const targetPosition = element.offsetTop - offset
        window.scrollTo({
          top: targetPosition,
          behavior: "smooth"
        })
      }
    },
    handleScroll() {
      if (!isScrollTriggered) {
        isScrollTriggered = true
        return
      }
      this.expandNavigation = false
      const anchors = this.navigationList.map(item => item.anchor).reverse() // 倒叙以便遍历判断匹配符合数据
      const offsetHeight = this.getOffsetHeight()
      const activeIndex = anchors.findIndex(anchor => {
        const element = document.querySelector("#anchor-" + anchor)
        if (!element) {
          // eslint-disable-next-line array-callback-return
          return
        }
        const elementRect = element.getBoundingClientRect()
        return elementRect.top < offsetHeight + 20
      })

      const currentAnchor = anchors[activeIndex < 0 ? anchors.length - 1 : activeIndex]
      if (this.currentAnchor === currentAnchor) {
        return
      }
      this.currentAnchor = currentAnchor
      this.debounceScrollToElement(this.currentAnchor)
    },
    getOffsetHeight() {
      const topWrapper = document.getElementById("top-content-wrapper")
      // header高度 + 导航高度 为偏移量
      return (parseFloat(topWrapper.style.height) + 0.1 + 0.53) * 100
    },
    /**
     * 滚动到不可见的导航项时将其变为可见
     */
    scrollToElement(anchor) {
      const element = document.querySelector(`[target-anchor="${anchor}"]`)
      element.scrollIntoView({ behavior: "smooth", block: "nearest" })
    }
  }
}
